import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ProjectService } from "../../services/project/project.service";
import { Project } from "../../interfaces/project";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { MzModalService, MzToastService } from "ng2-materialize";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";
import { Utils } from "../../utils/utils";
import { Questionnaire } from "../../interfaces/questionnaire";
import { QuestionnaireService } from "../../services/questionnaire/questionnaire.service";
import { CreateQuestionnaireDialogComponent } from "../create-questionnaire-dialog/create-questionnaire-dialog.component";
import { SendQuestionnaireComponent } from "../../components/send-questionnaire/send-questionnaire.component";

@Component({
  selector: "app-questionnaires",
  templateUrl: "./questionnaires.component.html",
  styleUrls: ["./questionnaires.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionnairesComponent implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @ViewChild("DeleteItemConfirmationModal")
  DeleteItemConfirmationModal: DeleteItemConfirmationDialogComponent;
  @ViewChild("CreateQuestionnaireModal")
  CreateQuestionnaireModal: CreateQuestionnaireDialogComponent;
  @ViewChild("SendQuestionnaire") SendQuestionnaire: SendQuestionnaireComponent;

  loading: boolean;
  project: Project;
  questionnaires: Array<Questionnaire> = [];
  newQuestionnaire = {} as Questionnaire;
  recipientsCount: number;
  inProgressCount: number;
  finishedCount: number;

  constructor(
    private projectService: ProjectService,
    public modalService: MzModalService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private questionnaireService: QuestionnaireService,
    private toastService: MzToastService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(async (params: { id: string }) => {
      await this.loadData(params.id);
      this.changeDetectorRef.detectChanges();
    });
  }

  async loadData(projectId: string) {
    this.loading = true;
    this.project = await this.projectService.getProjectByShortId(projectId);
    this.questionnaires = this.getSortedArray(
      await this.questionnaireService.getQuestionnairesByProjectId(
        this.project._id
      )
    );
    const recipients = this.questionnaires.map((x) => x.recipients[0]);
    this.recipientsCount = recipients.filter(
      (x, i) => recipients.indexOf(x) === i
    ).length;
    this.inProgressCount = this.questionnaires.filter(
      (x) => x.modified_at > x.created_at && !x.finished
    ).length;
    this.finishedCount = this.questionnaires.filter((x) => x.finished).length;
    this.loading = false;
    this.changeDetectorRef.detectChanges();
  }

  private getSortedArray(questionnaires) {
    return questionnaires.sort(
      (a: any, b: any) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );
  }

  async reloadProject() {
    await this.loadData(this.project.shortId);
  }

  async deleteQuestionnaire(questionnaire: Questionnaire) {
    let result = await this.DeleteItemConfirmationModal.getResultAsync();
    if (result === true) {
      this.loading = true;
      await this.questionnaireService.deleteQuestionnaireById(
        questionnaire._id
      );
      await this.reloadProject();
    }
    this.loading = false;
  }

  async sendQuestionnaireDialog() {
    await this.SendQuestionnaire.modalComponent.open();
  }

  async showQuestionnaire(questionnaire: Questionnaire) {
    await this.router.navigate([
      "projects",
      this.project.shortId,
      "questionnaires",
      questionnaire.shortId,
    ]);
  }

  async openNewQuestionnaireDialog() {
    this.CreateQuestionnaireModal.modalComponent.open();
  }

  async setPassword() {
    try {
      await this.projectService.setQuestionnairePassword(this.project);
      this.toastService.show("Passwort gespeichert!", 4000, "confirm-toast");
    } catch (error) {
      this.toastService.show(
        "Fehler! Nicht gespeichert",
        4000,
        "notification-toast"
      );
    }
  }

  async createQuestionnaireClicked(newQuestionnaire) {
    await this.questionnaireService.createQuestionnaire(newQuestionnaire);
    await this.reloadProject();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/questionnaires/questionnaires.component.ts